<template>
 <div class="col-md-12">
  <ConsulteGrid :columns="rows" :data-source="dataSource" :actions="true" @on-change-data-row="rowChange">
   <template #nome="context">
    <span :style="{ color: isUsuarioBloqueado(context.row) ? 'red' : '' }">
     {{ context.row.nome }}
    </span>
   </template>
   <template #tipoUsuario="context">
    <span :style="{ color: isUsuarioBloqueado(context.row) ? 'red' : '' }">
     {{ context.row.tipoUsuario }}
    </span>
   </template>
   <template #botaoEmprestimo="context">
    <button type="button"
     v-if="!isUsuarioBloqueado(context.row)"
     class="btn btn-outline-warning"
     @click="emprestimo(context.row)"
    >
     Empréstimos
    </button>
   </template>
   <template #botaoReserva="context">
    <button type="button"
     v-if="!isUsuarioBloqueado(context.row)"
     class="btn btn-outline-primary"
     @click="reserva(context.row)"
    >
     Reserva
    </button>
   </template>
  </ConsulteGrid>
 </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ConsulteGrid from "@/components/grid/ConsulteGrid.vue";
import { ConsulteGridColumnsModel } from "@/datasources/consulte-grid";
import BibUsuarioDataSource from "@/datasources/biblioteca/bibusuario/index.datasource";
import { BibUsuarioModel } from "@/models/biblioteca/bibusuario/bibusuario.model";
import router from "@/routes";
import { useStore } from "@/store";

export default defineComponent({
 name: "BibEmprestimoGridUsuario",
 components: { ConsulteGrid },
 methods: {
  rowChange(value: string, row: BibUsuarioModel) {
   console.log(value, row);
  },
  async emprestimo(row: BibUsuarioModel) {
   const isCentral =
    this.$route.path.endsWith("/0") ||
    this.$route.name === "bibemprestimocentral";
   const bibTipoUsuarioId = Number(
    (row as any).bibTipoUsuarioId ?? row.bibTipoUsuarioid
   );
   const segUsuarioId = Number((row as any).segUsuarioId);

   if (!Number.isFinite(bibTipoUsuarioId) || !Number.isFinite(segUsuarioId)) {
    return;
   }

   await router.push({
    name: isCentral ? "bibemprestimo_grid_central" : "bibemprestimo_grid_escola",
    params: {
     bibTipoUsuarioId: String(bibTipoUsuarioId),
     segUsuarioId: String(segUsuarioId),
    },
    query: {
     usuarioNome: String((row as any).nome ?? ""),
    },
   });
  },
  async reserva(row: BibUsuarioModel) {
   const isCentral =
    this.$route.path.endsWith("/0") ||
    this.$route.name === "bibemprestimocentral";
   const bibTipoUsuarioId = Number(
    (row as any).bibTipoUsuarioId ?? row.bibTipoUsuarioid
   );
   const segUsuarioId = Number((row as any).segUsuarioId);

   if (!Number.isFinite(bibTipoUsuarioId) || !Number.isFinite(segUsuarioId)) {
    return;
   }

   await router.push({
    name: isCentral ? "bibreserva_grid_central" : "bibreserva_grid_escola",
    params: {
     bibTipoUsuarioId: String(bibTipoUsuarioId),
     segUsuarioId: String(segUsuarioId),
    },
    query: {
     usuarioNome: String((row as any).nome ?? ""),
    },
   });
  },
  isUsuarioBloqueado(row: BibUsuarioModel) {
   return Number(row.bloqueioBiblioteca) === 1;
  },
  getGesEscolaId() {
   const isCentral =
    this.$route.path.endsWith("/0") ||
    this.$route.name === "bibemprestimocentral";

   return isCentral ? 0 : useStore().getters.getCodigoEscola;
  },
 },
 data() {
  return {
   dataSource: new BibUsuarioDataSource(0, 10, 0, 0, [], this.getGesEscolaId()),
   rows: [
    {
     text: "Nome",
     align: "center",
     cellsalign: "center",
     datafield: "nome",
     editable: false,
     filtertype: "text",
     filterable: true,
    },
    {
     text: "BibTipoUsuarioid",
     hidden: true,
     align: "center",
     cellsalign: "center",
     datafield: "bibTipoUsuarioid",
     editable: false,
     filtertype: "text",
     filterable: false,
    },
    {
     text: "Tipo de Usuario",
     align: "center",
     cellsalign: "center",
     datafield: "tipoUsuario",
     editable: false,
     filtertype: "text",
     filterable: false,
    },
    {
     text: "SegUsuarioId",
     hidden: true,
     align: "center",
     cellsalign: "center",
     datafield: "segUsuarioId",
     editable: false,
     filtertype: "text",
     filterable: false,
    },
    {
     text: "Aluno",
     hidden: true,
     align: "center",
     cellsalign: "center",
     datafield: "aluno",
     editable: false,
     filtertype: "checkbox",
     filterable: true,
    },
    {
     text: "Professor",
     hidden: true,
     align: "center",
     cellsalign: "center",
     datafield: "professor",
     editable: false,
     filtertype: "checkbox",
     filterable: true,
    },
    {
     text: "Funcionario",
     hidden: true,
     align: "center",
     cellsalign: "center",
     datafield: "funcionario",
     editable: false,
     filtertype: "checkbox",
     filterable: true,
    },
    {
     text: "Empréstimos",
     align: "center",
     cellsalign: "center",
     datafield: "botaoEmprestimo",
     editable: false,
     filtertype: "text",
     filterable: false,
    },
    {
     text: "Reserva",
     align: "center",
     cellsalign: "center",
     datafield: "botaoReserva",
     editable: false,
     filtertype: "text",
     filterable: false,
    },
   ] as ConsulteGridColumnsModel[],
  };
 },
});
</script>
